import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { Breed } from 'src/app/models/breed.model';
import { Extern } from 'src/app/models/extern.model';
import { AuthService } from 'src/app/services/auth.service';
import { BreedService } from 'src/app/services/breed.service';
import { ExternService } from 'src/app/services/extern.service';
import { SettingsService } from 'src/app/services/settings.service';
import { DeleteExternComponent } from '../delete/delete.component';
import { EditExternComponent } from '../edit/edit.component';
import { getAnimalTypeLabel } from 'src/app/constants/animal-types.constants';

@Component({
    selector: 'app-externs-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    standalone: false
})
export class ListExternsComponent implements OnInit {

	public loading = true;
	public externs: Extern[] | null = [];

	constructor(
		protected externService: ExternService,
		protected dialogService: NbDialogService,
		protected router: Router,
		protected authService: AuthService,
		protected formBuilder: UntypedFormBuilder,
		protected settingsService: SettingsService,
		private toastrService: NbToastrService
	) { }

	ngOnInit(): void {
		this.reloadExterns();
	}

	private reloadExterns(): void {
		this.externService.getAll().subscribe(
			externs => {
				this.externs = externs;
			}
		);
	}

	public addAction(): void {

		this.dialogService.open(EditExternComponent).onClose.subscribe((externId: number | null) => {
			if (externId) {
				this.reloadExterns();
			}
		});
	}

	public deleteAction(extern: Extern): void {

		this.dialogService.open(DeleteExternComponent, { context: { extern } }).onClose.subscribe((response) => {
			if (response.deleted) {
				this.reloadExterns();
			}
		});
	}

	/**
	 * Retourne les labels des types d'animaux séparés par des virgules
	 */
	public getAnimalTypesLabel(animalTypeIds: number[] | undefined): string {
		if (!animalTypeIds || animalTypeIds.length === 0) {
			return '-';
		}
		return animalTypeIds.map(typeId => getAnimalTypeLabel(typeId)).join(', ');
	}
}
